import {Injectable} from '@angular/core';
import {SubTypeMap, Attributes} from '../../../../common/models/label-expression.model';

@Injectable({
    providedIn: 'root'
})
export class LabelExpressionBuildService {
    build(title: string, subTypeMap: SubTypeMap, attributes: Attributes, polygons?: any) {
        const subTypeEntry = subTypeMap[attributes.featuresubtype];
        if (!subTypeEntry) {
            console.debug(title + ': featuresubtype ' + attributes.featuresubtype + 'not supported');
            return null;
        }
        return subTypeEntry ? subTypeEntry.function(attributes, polygons) : null;
    }
}
